import { SET_MAP_DATA, SET_MAP_DISPLAY } from '../actions/mapActions';
import type { MapAction } from '../actions/mapActions';
import type { MapState } from '../../types/map';

const initialState: MapState = {
    coordinates: null,
    properties: null,
    display: ''
}

const mapReducer = (state: MapState = initialState, action: MapAction): MapState => {
    switch (action.type) {  
        case SET_MAP_DATA:
            return {
                ...state,
                coordinates: action.payload.coordinates,
                properties: action.payload.properties
            }
        case SET_MAP_DISPLAY:
            return {
                ...state,
                display: action.payload ? 'path' : 'markers'
            }
        default:
            return state
        }
}

export default mapReducer;
